import { render, staticRenderFns } from "./RoleUserTable.vue?vue&type=template&id=49a63858&scoped=true&"
import script from "./RoleUserTable.vue?vue&type=script&lang=ts&"
export * from "./RoleUserTable.vue?vue&type=script&lang=ts&"
import style0 from "./RoleUserTable.vue?vue&type=style&index=0&id=49a63858&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a63858",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
